export default __webpack_public_path__ + "static/media/3DShape_01.9ef30847.png";